module.exports = __webpack_public_path__ + "img/bri.90fb297e.svg";